var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verification-help-actions"},[_c(_vm.actionOne,{tag:"component"},[_vm._v("Resend now")]),_vm._v(" or "),_c(_vm.actionTwo,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }